<template>
    <div>
        <el-dialog
            class="attachment receipt-signattachment"
            title="图片查看"
            :visible.sync="diaShaow"
            :before-close="handleStartClose"
            :close-on-click-modal="false"
            width="50%"
        >
            <div class="attachment-title">
                <!-- <el-row :gutter="20">
                    <el-col :span="13">
                        <div class="grid-content bg-purple">
                            <span>上传人</span>：
                            <span>{{updateUserName}}</span>
                        </div>
                    </el-col>
                    <el-col :span="11">
                        <div class="grid-content bg-purple">
                            <span>上传时间</span>：
                            <span>{{uploadTime}}</span>
                        </div>
                    </el-col>
                </el-row> -->
            </div>

            <div class="attachment-left">
                <div class="pictures-content">
                    <ul id="viewers" class="viewers-c">
                        <li class="imglists">
                            <img
                                :src="imgUrl"
                                class="imgshow"
                            />
                        </li>
                    </ul>
                </div>
            </div>
            <div slot="footer" class="dialog-footer"></div>
        </el-dialog>
    </div>
</template>

<script>
import Viewer from 'viewerjs';
import 'viewerjs/dist/viewer.css';
export default {
    props: {
        updateUserName: {
            type: String,
            default: ''
        },
        imgUrl: {
            type: String,
            default: ''
        },
        uploadTime: {
            type: String,
            default: ''
        },
        diaShaow: {
            type: Boolean,
            default: false
        },
        imgLookName: {
            type: String
        },
        data: {
            type: Object
        }
    },
    data() {
        return {
            dialogLoading: {}
        };
    },
    methods: {
        handleStartClose() {
            this.$emit('handleStartClose', {
                imgLookName: this.imgLookName,
                data: this.data
            });
        },
        updateViewer() {
            this.viewer.destroy();
            setTimeout(() => {
                this.initViewer();
            });
        },
        initViewer() {
            const barOptions = { show: true, size: 'small' };
            this.viewer = new Viewer(document.getElementById('viewers'), {
                inline: true,
                title: false,
                navbar: false,
                button: true,
                toolbar: {
                    zoomIn: barOptions,
                    zoomOut: barOptions,
                    reset: barOptions,
                    rotateLeft: barOptions,
                    rotateRight: barOptions
                }
            });
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.initViewer();
        });
    },
    beforeDestroy() {
        this.viewer.destroy();
    }
};
</script>

<style lang="less">
@import './Picture.less';
</style>
